import { SAVE_RISK_TRANSLATION } from '../constants.js';
import { getCurrentLanguage } from '../helpers/local_storage.js';

export function saveRiskTranslation(row, translation) {
  const language = getCurrentLanguage();
  return { type: SAVE_RISK_TRANSLATION, row, language, translation }
}


// WEBPACK FOOTER //
// ./src/actions/translations.js